//---- components ---------
//---- mixins -------------
//---- services -----------
import { appLocalStorage } from "@/app/services/app-storage.js";
//---- other --------------
//---- 3rd-parties --------
import isEqual from "lodash/isEqual";

export const initialState = {
     isSolo: appLocalStorage.getItem('isSolo') == "true",
  connected: false,
     status: null,
     onlineAuthenticated: false,
     soloBackendNotRunning: false,
}

export const kmOffline = {
  namespaced: true,

  state: { ...initialState }, // copy initial state

  actions: {
    updateIsSolo({commit}, value) {
      commit("updateIsSolo", value);
      if (typeof value != "undefined" && value != null)
        appLocalStorage.setItem('isSolo', value)
    },
    updateConnectedState({commit, state}, value) {
      if (!isEqual(state.connected, value))
        commit("updateConnectedState", value);
    },
    updateStatus({commit}, value) {
      commit("updateStatus", value);
    },
    onlineAuthenticated({commit}, value) {
      commit("updateOnlineAuthenticated", value);
    },
    setSoloBackendRunninStatus({commit}, running) {
      commit("setSoloBackendRunninStatus", running);
    }
  },

  mutations: {
    updateIsSolo(state, value) {
        state.isSolo = value;
    },
    updateConnectedState(state, value) {
      state.connected = value;
    },
    updateStatus(state, value) {
      state.status = value;
    },
    updateOnlineAuthenticated(state, value) {
      state.onlineAuthenticated = value;
    },
    setSoloBackendRunninStatus(state, running) {
      state.soloBackendNotRunning = !running;
    }
  },

  getters: {
    isKMOffline: (state) => {
      let isSolo = state.isSolo;
      if (isSolo == null || typeof isSolo == "undefined")
        isSolo = appLocalStorage.getItem('isSolo') == "true";
      return isSolo || false
    },
    isKMOfflineKnown: (state) => {
      let isSolo = state.isSolo;
      if (isSolo == null || typeof isSolo == "undefined")
        isSolo = appLocalStorage.getItem('isSolo') == "true";

      return isSolo != null && typeof isSolo != "undefined"
    },
    isOnlineAuthenticated: (state) => {
      return state.onlineAuthenticated;
    },
    isConnected: (state) => {
      return state.connected
    },
    status: (state) => {
      return state.status
    },
    soloBackendNotRunning: (state) => {
      return state.soloBackendNotRunning
    }
  }
};